export enum AuthMethod {
  OneFactor = 1,
  TwoFactorBySms = 2,
  TwoFactorByEmail = 4,
  TwoFactorByKba = 8,
}
